import { fromISO, subtractDays, getCurrentDate } from '@libs/focus-frontend-dates/src/date';
import { createSelector } from 'reselect';

import { AccountState } from './reducer';

export const selectAccountState = (state: { account: AccountState }) => state.account;
export const selectAccountActivatedDate = createSelector([selectAccountState], (state) => state.activatedAt);

export const selectAccountIsOnboarded = createSelector([selectAccountActivatedDate], (activationDate) => {
  if (!activationDate) {
    return false; // account is still a demo account
  }

  const formattedActivationDate = fromISO(activationDate);
  const currentDateMinus60Days = subtractDays(getCurrentDate(), 60);

  return formattedActivationDate < currentDateMinus60Days;
});

export const selectAccountIsInTrial = createSelector(selectAccountState, (account) => account.isTrial);
export const selectAccountPackage = createSelector(selectAccountState, (account) => account.packageType);
export const selectTrialEndsAt = createSelector(selectAccountState, (account) => {
  const trialEndsAt = account.trialEndsAt;
  if (!trialEndsAt) {
    return null;
  }

  return fromISO(trialEndsAt);
});
export const selectIsTrialOrOnboardingAccount = createSelector(
  [selectAccountIsInTrial, selectAccountIsOnboarded],
  (accountIsInTrial, accountIsOnboarded) => accountIsInTrial || !accountIsOnboarded,
);
export const selectAccountCountry = createSelector(selectAccountState, (account) => account.country);
export const selectAccountCurrency = createSelector(selectAccountState, (account) => account.currency);
export const selectAccountIsLinkedToDistributorChannel = createSelector(
  selectAccountState,
  (account) => account.isDistributorChannel,
);
